import { v2 } from './versions/v2';

const api = {
  v2,
};

export { api };
